// A thin hover-reveal bar for navigation rails; everywhere else keeps the native one, which is
// easier to grab. Pick by the surface the scroller sits on, not by the thumb's own colour.
const thinScrollbarSx = (thumb: string) => ({
  // Chrome 121+ honours these and then ignores every webkit rule below, so the branches
  // have to stay mutually exclusive.
  '@supports not selector(::-webkit-scrollbar)': {
    scrollbarWidth: 'thin',
    scrollbarColor: 'transparent transparent',
    '&:hover, &:focus-within': { scrollbarColor: `${thumb} transparent` },
  },
  '&::-webkit-scrollbar': { width: 6, height: 6 },
  '&::-webkit-scrollbar-button': { display: 'none' },
  '&::-webkit-scrollbar-track': { background: 'transparent' },
  '&::-webkit-scrollbar-thumb': { backgroundColor: 'transparent', borderRadius: 3 },
  '&:hover::-webkit-scrollbar-thumb, &:focus-within::-webkit-scrollbar-thumb': {
    backgroundColor: thumb,
  },
});

export const DARK_SCROLLBAR_SX = thinScrollbarSx('rgba(255, 255, 255, 0.3)');
export const LIGHT_SCROLLBAR_SX = thinScrollbarSx('rgba(0, 0, 0, 0.25)');
